export enum ESignInWithMagicUriFormUsageContext {
  SIGN_IN_PAGE = 'SIGN_IN_PAGE',
  STAND_ALONE = 'STAND_ALONE',
}
